module.exports = __webpack_public_path__ + "static/media/trekspresso-1.9fc3b3da.jpg";